<template>
<div class="mt-5">
<v-card class="mx-auto" max-width="600">
    <v-card-text>
         <div class="pa-3 pb-0 html" v-if="page">
            <div v-html="page.html"  v-if="page.html" />
         </div>
    </v-card-text>
</v-card>
</div>
</template>

<script>
export default {

     props: {

        page: null

    },

    data: () => ({

    }),

    computed: {
        member_id() {
            return this.$MEMBER_ID
        }
    },

    watch: {

        member_id(val) {
            this.goHome();
        }

    },
    methods: {

        goHome() {
            if (this.$MEMBER_ID) {
                this.$router.push({
                    name: 'Home'
                })
            }
        }

    },
    created() {

        this.goHome();

    },
};
</script>
